export interface ErrorResponseMap {
	[key: string]: string;
}

export const ErrorResponseMapDefs = {
	// {psma_host}/predictive/address/:address_id
	GetAddress: {
		"400": "No address id given.",
		"404": "Cannot find address with id.",
	},

	// {psma_host}/predictive/address?addressType=mailing&maxNumberOfResults=5&query=:query
	GetAddressSuggestions: {
		"400": "Address query must be at least 3 characters long.",
	},

	// {mrtm_host}/products?type=:type
	GetProducts: {
		"400": "Could not get products.",
	},

	// {mrtm_host}/products?type=PLAN
	GetPlan: {
		"400": "Could not get plan.",
	},

	// {mrtm_host}/payment/total?products=:product_ids&campaigns=:campaign_ids
	GetPlanSummary: {
		"400": "Must have at least one product.",
		"404": "Campaign not found.",
		"500": "Product not found.",
	},

	// {mrtm_host}/portin/check?portNumber=:phone_number
	VerifyPhoneNumber: {
		"400": "Invalid phone number.",
		"409": "This phone number is not available for porting.",
	},

	// {mrtm_host}/auth/password/validate
	ValidatePassword: {
		"404": "This is not the correct password.",
	},

	// {mrtm_host}/auth/password
	ChangePassword: {
		"409": "Sorry, you can’t use a previous password.",
		"404": "This reset password link is not valid.",
	},

	// {mrtm_host}/auth/validate?username=:email
	VerifyEmail: {
		"400":
			"Email address already associated with an account. Please use a different email address.",
	},

	// {mrtm_host}/campaigns?code=:promo_code
	VerifyPromoCode: {
		"400": "A valid code is required.",
		"404": "Invalid code.",
	},

	// {mrtm_host}/onboarding
	Onboarding: {
		"400": "Bad input.",
		"406": "Please check your card details in the app before trying again.",
	},

	// POST {{mrtm host}}/auth/verify-email
	ActivateVerifyEmail: {
		"409": "This email was already verified. Congratulations.",
		"417":
			"The token you supplied is not valid. You will need to retry validation.",
		"428":
			"The token you supplied is expired. You will need to retry validation.",
	},

	// {{mrtm host}}/auth/login
	Login: {
		"401": "Invalid credentials. Please try again.",
		"402": "Maximum login attempts exceeded. Please try again later.",
	},

	// {{mrtm host}}/sim/validate
	VerifySIM: {
		"404":
			"That SIM is not available for activation. Please try another SIM or contact us.",
	},

	// POST {{mrtm host}}/service/activate
	ActivateService: {
		"422": "Service already activated. Please try again or contact us.",
		"428":
			"Something went wrong with your order. Please try again or contact us.",
	},

	GetDeliveryETA: {},

	// POST {mrtm_host}/service/otp
	VerifyOTPCode: {
		"400": "This code doesn't look right. Try again.",
		"404": "This code doesn't look right. Try again.",
		"409": "Sorry, the code has expired.",
		"410": "Sorry, the code has expired.",
	},

	// POST {{mrtm_host}}/service/order/sim
	ConfirmOrderNewSIM: {
		"428": "Link expired, please try again.",
	},

	Defaults: {
		"400": "Something went wrong.\nPlease contact us.",
		"401": "Something went wrong.\nPlease contact us.",
		"403": "Something went wrong.\nPlease contact us.",
		"404": "Something went wrong.\nPlease contact us.",
		"407": "Need OTP Auth.",
		"500": "Something went wrong.\nPlease contact us.",
		"502": "Something went wrong.\nPlease contact us.",
	},
};
